import styled from 'styled-components';

export const RelativeDiv = styled.div`
  position: relative;
`;

export const WeekCardBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  text-align: center;
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 16%);
  padding: 10px 14px;
  margin: 10px 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &.weekCardOpacity {
    opacity: 0.5;
  }

  &:hover {
    transform: scale(1.05);
  }

  .title {
    font-size: 14px;
    font-weight: 500;
    color: hsl(0deg, 0%, 0%, 87%);
    padding-bottom: 4px;
  }

  .weekNumber {
    font-weight: 600;
    font-size: clamp(20px, 2vw, 26px);
    color: hsl(0deg, 0%, 0%, 80%);
    padding-top: 4px;
  }

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    padding-bottom: 4px;
  }

  @media (max-width: 720px) {
    cursor: default;
    margin: 10px 4px 10px 10px;
    padding: 10px;
  }
`;

export const WeekCardSection = styled.div`
  display: flex;
  column-gap: 20px;
`;
